import * as basicLightbox from 'basiclightbox';

const getLocationInfo = (url) => {
	const location = document.createElement('a');
	location.href = url;
	return location;
};

const initSpeedBump = () => {
	const currentDomain = window.location.hostname;
	const links = document.querySelectorAll('a:not([href*="youtube.com"]):not([href*="youtu.be"]):not([href*="vimeo.com"]):not([href*="wistia.com"]):not([href*=".mp4"]):not([href*="tel"]):not([href*="mailto"])');
	const speedBump = document.querySelector('.em-speedbump');

	if (speedBump) {
		links.forEach((link) => {
			link.onclick = (e) => {
				const url = e.target.closest('a').getAttribute('href');
				const nextLocation = getLocationInfo(url);
				const nextDomain = nextLocation.hostname;
				/* eslint-disable-next-line */
				const allowedDomains = speedbump_allowed_domains;
				let isAllowed = false;

				allowedDomains.map((domain) => {
					if ((domain && nextDomain === domain.trim()) || (nextDomain === (`www.${domain}`).trim())) {
						isAllowed = true;
					}
					return domain;
				});

				if (isAllowed) {
					return;
				}

				if (currentDomain !== nextDomain && url.indexOf('http') > -1) {
					e.preventDefault();
					const closeButton = '<button class="speedbump-close btn btn--secondary">Stay on this Website</button>';
					const continueButton = `<a href="${url}" target="_blank" rel="noopener norefferer" class="speedbump-continue btn btn--primary">Continue to the Website</a>`;
					const speedBumpInner = speedBump.querySelector('.speedbump');
					const speedBumpMessage = `<div class="speedbump">${speedBumpInner.innerHTML}${closeButton}${continueButton}</div>`;

					const instance = basicLightbox.create(
						speedBumpMessage,
						{
							closable: false,
							afterShow: () => {
								document.querySelector('.speedbump-close').onclick = () => { instance.close(); };
								document.querySelector('.speedbump-continue').onclick = () => { instance.close(); };
							},
						},
					);
					instance.show();
				}
			};
		});
	}
};

document.addEventListener('DOMContentLoaded', initSpeedBump);
